module.exports = __webpack_public_path__ + "img/logo.0b03ad06.png";